import api from './axios';

export const getPayments = (params) => api.get('/payments', { params });
export const getStudentPayments = (studentId, params) => api.get(`/students/${studentId}/payments`, { params });
export const getStudentCharges = (studentId) => api.get(`/students/${studentId}/charges`);
export const addPayment = (studentId, data) => api.post(`/students/${studentId}/payments`, data);
export const deletePayment = (paymentId) => api.delete(`/payments/${paymentId}`);